module.exports = __webpack_public_path__ + "img/carousel-2.19ee824.png";